import {sessionStore} from '@store/session/session.store';
import {getCurrentUserDataSource} from '@store/session/session.requests';
import {select} from '@ngneat/elf';
import {UserTypes} from '@store/session/session.model';

export class SessionQuery {
  store = sessionStore;

  currentUser$ = getCurrentUserDataSource.data$();

  hasAccessToAdmin$ = () => this.store.pipe(
    select((state) => state.user?.userRoles?.includes(UserTypes.Admin) || state.user?.userRoles.includes(UserTypes.AccountManager))
);

  get currentUser() {
    return this.store.getValue().user;
  }
}

export const sessionQuery = new SessionQuery();
